
import PhoneNumber from "awesome-phonenumber";
export default {
    props: {
        rules: {
            type: Array,
            default: () => [],
        },
        value: {
            type: String,
            default: "",
        },
        defaultCountry: {
            type: String,
            default: "LA",
        },
        currentValue: {
            type: String,
            default: "",
        },
    },
    data: () => ({
        phone: null,
        phoneValid: true,
    }),
    computed: {
        formRule() {
            return [
                (v) => {
                    const valid = !!v;
                    if (!valid) {
                        this.$emit("onvalidchange", { valid, number: {} });
                    }
                    return valid || this.tl("enterPhoneNumber");
                },
                (v) => {
                    const valid = !v || /^[\d\s ()+\\-]+$/.test(v);
                    if (!valid) {
                        this.$emit("onvalidchange", { valid, number: {} });
                    }
                    return valid || this.tl("phoneNumberMustNotContainChar");
                },
                (v) => {
                    const valid = !v || this.phoneValid;
                    if (!valid) {
                        this.$emit("onvalidchange", { valid, number: {} });
                    }
                    return valid || this.tl("phoneNumberFormatInvalid");
                },
                ...this.rules,
            ];
        },
    },
    watch: {
        value(value) {
            this.phone = value;
        },
    },

    mounted() {
        this.phone = this.value;
    },
    methods: {
        onValidateChange(obj) {
            this.phoneValid = obj?.isValid;
            this.$emit("input", obj?.number?.e164);
            if (this.phoneValid) {
                this.$emit("onvalidchange", {
                    valid: this.phoneValid,
                    number: obj?.number,
                });
            }
        },
        onCountryChange(evt) {
            const validate = PhoneNumber(this.phone, evt.iso2);
            this.phoneValid = validate?.g?.valid;
            if (this.phoneValid) {
                this.$emit("onvalidchange", {
                    valid: this.phoneValid,
                    number: validate?.g?.number,
                });
            }
        },
    },
};
